import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class ExpensesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/expenses' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/expenses/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/expenses/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/expenses/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/expenses/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/expenses/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Expenses = new ExpensesApi();
